import React, { useEffect, useState } from "react";
import "./SenderCookieBanner.css";
import { apiJsonRequest } from "../../utils/apiRequest";
import { ACCEPT_ALL, ESSENTIAL_ONLY, getSenderChoice, isSenderContext, setSenderChoice } from "../../utils/cookieConsentUtils";
import { PRIVACY_PAGE_PATH } from "../../utils/privacyPage";
import CookiePreferencesButton from "./CookiePreferencesButton";

const getSenderIconPosition = () => (window?.kzSenderConsent?.iconPosition === "left" ? "left" : "right");

const saveIconPosition = (position) => {
  window.kzSenderConsent.iconPosition = position;
  apiJsonRequest("/sender_cookie_consent/icon_position.json", "PATCH", { position }).catch((error) => console.error(error));
};

const SenderCookieBanner = () => {
  const [open, setOpen] = useState(() => isSenderContext() && !getSenderChoice());

  useEffect(() => {
    if (!isSenderContext()) return undefined;
    const reopen = () => setOpen(true);
    window.addEventListener("openCookieConsentModal", reopen);
    return () => window.removeEventListener("openCookieConsentModal", reopen);
  }, []);

  if (!isSenderContext()) return null;
  if (!open) {
    return <CookiePreferencesButton position={getSenderIconPosition()} onPositionChange={saveIconPosition} />;
  }

  const choose = (status) => {
    setSenderChoice(status);
    setOpen(false);
    apiJsonRequest("/sender_cookie_consent.json", "PATCH", { status }).catch((error) => console.error(error));
  };

  return (
    <div className="kz-sender-cookie-banner" role="region" aria-label="Cookie preferences">
      <p className="kz-sender-cookie-banner__text">
        Essential cookies keep you signed in. Accept all also loads embedded videos, GIF search, forms and profile
        images from third-party services, which may set their own cookies.
      </p>
      <div className="kz-sender-cookie-banner__actions">
        <button type="button" className="kz-sender-cookie-banner__btn" onClick={() => choose(ESSENTIAL_ONLY)}>
          Essential only
        </button>
        <button type="button" className="kz-sender-cookie-banner__btn" onClick={() => choose(ACCEPT_ALL)}>
          Accept all
        </button>
      </div>
      <p className="kz-sender-cookie-banner__footnote">
        <a href={PRIVACY_PAGE_PATH} target="_blank" rel="noopener noreferrer">Privacy Notice</a> · Change this anytime
        with the cookie icon.
      </p>
    </div>
  );
};

export default SenderCookieBanner;
